import { SerializedCondition } from 'cio/types/conditions/condition';

export const ALLOWED_DATA_INDEX_TYPES = ['attributes', 'events'];

export const DATA_INDEX_TYPE_ACTIVITY_LOGS = {
  attribute: 'attribute_change',
  event: 'event',
};

export const DATA_INDEX_TYPE_ICONS = {
  attribute: 'person',
  event: 'event',
};

export interface DataIndexCampaign {
  campaignId: number;
  name: string;
  usage: string[];
}

export interface DataIndexSegment {
  segmentId: number;
  name: string;
  archived: boolean;
  conditions: SerializedCondition[] | null;
}
